import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

const tripAmountsFieldFilter = (field: IField): boolean =>
  !field.hasFeature(FieldFeature.MONETARY_VALUE);

export default tripAmountsFieldFilter;
